export const PLAN_SETTINGS = {
  BUSINESS_STARTER_ID: 'prod_RYRCN77CHkkkia',
  BUSINESS_ESSENTIALS_ID:
    import.meta.env.VITE_ENV_TYPE === 'PROD' ? 'prod_RYRCcsV8DVKCqi' : 'prod_TpjTgex2F6wGc5',
  BUSINESS_GROWTH_ID:
    import.meta.env.VITE_ENV_TYPE === 'PROD' ? 'prod_RYRCkepP2K8ilf' : 'prod_TpjSNPaG6DpJAt',
  PREMIUM_ID: 'prod_OyaXSNJ9zJyeyD',
  BUSINESS_STARTER_ANNUAL_ID: 'prod_TqOvTVYYzyJdo9',
  BUSINESS_ESSENTIALS_ANNUAL_ID:
    import.meta.env.VITE_ENV_TYPE === 'PROD' ? 'prod_TqP9KBXHZYDtud' : 'prod_Tu9BOh7d9RE32W',
  BUSINESS_GROWTH_ANNUAL_ID:
    import.meta.env.VITE_ENV_TYPE === 'PROD' ? 'prod_TqPD9XNmKmmmji' : 'prod_Tu9BdV1QSWzHD8',
  ESIGN_ONLY_ID:
    import.meta.env.VITE_ENV_TYPE === 'PROD' ? 'prod_UdqGgEwt4H1wla' : 'prod_UcnuV4DTZSRzUP',
  ESIGN_ONLY_ANNUAL_ID:
    import.meta.env.VITE_ENV_TYPE === 'PROD' ? 'prod_UdqJTIeVCpWCLT' : 'prod_Ucnu1Le82tCE7u',
};
